import { useEffect, useState } from "react";

/**
 * Het merk van de opvang in de kop: haar eigen logo als ze er een heeft, anders een neutraal teken.
 *
 * <p><b>Het logo komt van het platform</b>, dezelfde plek waar de opvangpagina op DierMatch hem
 * vandaan haalt ({@code /api/public/opvangen/{sleutel}/huisstijl}). Zo staat er geen tweede kopie die
 * achterloopt zodra een asiel zijn logo vervangt.
 *
 * <p><b>Geen logo is geen gat.</b> Heeft een opvang er geen ingesteld, dan staat er een neutraal
 * teken met haar naam ernaast — herkenbaar genoeg, en beter dan een leeg vak of een gebroken plaatje.
 */
export function AfstandMerk({ opvangSleutel, naam }: { opvangSleutel: string; naam: string }) {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  useEffect(() => {
    let levend = true;
    fetch(`/api/public/opvangen/${encodeURIComponent(opvangSleutel)}/huisstijl`)
      .then((r) => (r.status === 200 ? r.json() : null))
      .then((h: { logoUrl?: string } | null) => {
        if (levend && h?.logoUrl) setLogoUrl(h.logoUrl);
      })
      .catch(() => { /* geen logo is geen fout; het neutrale teken blijft staan */ });
    return () => { levend = false; };
  }, [opvangSleutel]);

  return (
    <div className="afst__merk">
      {logoUrl ? (
        <img className="afst__merklogo" src={logoUrl} alt="" onError={() => setLogoUrl(null)} />
      ) : (
        <span className="afst__merkteken" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
            <circle cx="7" cy="9" r="2.4" /><circle cx="12" cy="6.5" r="2.4" />
            <circle cx="17" cy="9" r="2.4" />
            <path d="M12 11c3 0 5.5 2.4 5.5 5 0 2-1.6 3.2-3.4 3.2-1 0-1.6-.4-2.1-.4s-1.1.4-2.1.4C8.1 19.2 6.5 18 6.5 16c0-2.6 2.5-5 5.5-5Z" />
          </svg>
        </span>
      )}
      <span className="afst__merknaam">
        <strong>{naam || "Dierenopvang"}</strong>
        <small>Afstandsportaal</small>
      </span>
    </div>
  );
}
